import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { TableCellComponent } from '@pct-ng/feature-table-material';
import { StatusComponent } from '../../../component/status.component';

type StatusCode = 'Active' | 'Inactive' | 'RecycleBin';
@Component({
  selector: 'cappus-status-cell-component',
  templateUrl: './status-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block min-w-[50px] max-w-[50px]',
  },
  imports: [StatusComponent],
})
export class StatusCellComponent<T> implements TableCellComponent<T, StatusCode> {
  readonly rowItem = input.required<T>();
  readonly value = input.required<StatusCode>();
  readonly params = input.required();
}
